import { ArtistState } from "explorer/reducers/artistas";
import { Trans, useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { ReactComponent as DistroIcon } from "shared/assets/images/icon-distribution-side-menu.svg";
import { DistributionStatusEnum } from "shared/enums/DistributionStatusEnum";

const DistroContent = () => {
  const { t } = useTranslation();
  const { userArtist } = useSelector((state: ArtistState) => state.artists);

  // if (
  //   userArtist?.distribution?.status === DistributionStatusEnum.Signed &&
  //   !distroToken
  // ) {
  //   return (
  //     <>
  //       <span className="titulo">
  //         {t("pages.EstagioArtista.distoLiberadoTitulo")}
  //       </span>
  //       <span className="divider" />
  //       <h1>{t("pages.EstagioArtista.tokenError")}</h1>
  //       <p className="body-regular">
  //         {t("pages.EstagioArtista.tokenErrorTexto")}
  //       </p>
  //     </>
  //   );
  // }

  return (
    <>
      {userArtist?.distribution?.status === DistributionStatusEnum.Signed ? (
        <>
          <span className="titulo">
            {t("pages.EstagioArtista.distoLiberadoTitulo")}
          </span>
          <span className="divider" />
          <h1>{t("pages.EstagioArtista.distribuaAgora")}</h1>
          <p className="body-regular">
            {t("pages.EstagioArtista.distroLiberadoTexto")}
          </p>
        </>
      ) : (
        <>
          <span className="titulo">
            {t("pages.EstagioArtista.distoLiberadoTituloSimples")}
          </span>
          <span className="divider" />
          <h1>{t("pages.EstagioArtista.distoLiberadoTitulo")}</h1>
          <p className="strong-escuro">
            <Trans i18nKey={t("pages.EstagioArtista.distribuicaoTexto")} />
          </p>
        </>
      )}
    </>
  );
};

const CardDistro: React.FC = () => {
  const { t } = useTranslation();
  const history = useHistory();

  const { userArtist } = useSelector((state: ArtistState) => state.artists);

  const showCTADistroStrm = () =>
    userArtist?.distribution?.available ||
    userArtist?.distribution?.status === DistributionStatusEnum.Pending ||
    userArtist?.distribution?.status === DistributionStatusEnum.Signed;

  if (!showCTADistroStrm()) return null;

  return (
    <div className="card-outra-sessao">
      <DistroIcon className="icon amarelo" />

      <DistroContent />
      {userArtist?.distribution?.status !== DistributionStatusEnum.Signed && (
        <button
          className="botao-roxo"
          onClick={() => history.push("/distribuicao")}
        >
          {t("pages.EstagioArtista.distribuaComStrm")}
        </button>
      )}
      <span style={{ display: "block", visibility: "hidden", height: 44 }} />
    </div>
  );
};

export default CardDistro;
